module.exports = __webpack_public_path__ + "static/media/xushi-logo.f816198f.jpg";